import type { State } from '../../types';
import { LocalDate } from '../../../utilities/local-date';

export function now(state: State): LocalDate {
  return LocalDate.fromString(state.today);
}
